/** @jsx jsx */
import React from 'react'
import { Flex, jsx, Text } from 'theme-ui'

const CheckboxInput = React.forwardRef(
  ({ defaultChecked, label, name, ...props }, ref) => {
    return (
      <Flex>
        <input
          type="checkbox"
          defaultChecked={defaultChecked}
          name={name}
          id={name}
          ref={ref}
          {...props}
        />
        <Text as="label" variant="body3" htmlFor={name} ml={1} mt="-2px">
          {label}
        </Text>
      </Flex>
    )
  }
)
export default CheckboxInput
